var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",class:{'loading--fullscreen': _vm.fullscrean}},[_c('div',{staticClass:"loading__content"},[_c('div',{staticClass:"loading__spinner",attrs:{"aria-hidden":"true"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.text),expression:"text"}],staticClass:"loading__text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }